// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb[data-v-7750ddae]{height:-moz-fit-content;height:fit-content;padding:16px 0;background-color:#585455;letter-spacing:1.5px}.breadcrumb__link[data-v-7750ddae]{color:#fff;font-size:16px}.breadcrumb__separate[data-v-7750ddae]{padding:0 6px;color:#fff}@media(max-width:1365px){.breadcrumb[data-v-7750ddae]{padding:7px 0}.breadcrumb__link[data-v-7750ddae]{font-size:14px}}", ""]);
// Exports
module.exports = exports;
